import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { heroIncludes, MOCKUP_URL } from '../../data/content';
export function Hero() {
  return <header className="relative w-full bg-ink" data-id="element-198" data-mp="cw4bxs0iwktc">
      <div className="bg-alert px-4 py-2.5 text-center font-display text-base font-bold uppercase tracking-wide text-white sm:text-lg" data-id="element-199" data-mp="cu9tckcq54sf">
        6 Practical Diagnostic Volumes + 5 Professional Bonuses — Just $27 Today
      </div>

      <div className="mx-auto grid max-w-6xl items-center gap-8 px-4 pb-14 pt-8 sm:pt-12 lg:grid-cols-[1.05fr_1fr] lg:gap-12 lg:pb-20" data-id="element-200" data-mp="ms7olrt041uj">
        <div className="text-center lg:text-left" data-id="element-201" data-mp="vm2mcersmq05">
          <p className="font-display text-xl font-extrabold uppercase tracking-wide text-brand sm:text-2xl" data-id="element-202" data-mp="vofaj9o59wln">
            Automotive No-Start Diagnostic Blueprint™
          </p>
          <h1 className="mt-3 font-display text-[40px] font-black uppercase leading-[0.98] text-white sm:text-6xl lg:text-[64px]" data-id="element-203" data-mp="15m39ycwp3sa5">
            Turn Any No-Start Complaint Into a <span className="text-brand" data-id="element-204" data-mp="9o2r3owkawon">Documented 6-Step</span> Diagnostic Workflow
          </h1>
          <p className="mt-4 text-lg leading-relaxed text-body sm:text-xl" data-id="element-205" data-mp="4ogd3d8wtces">
            From initial symptom to your next evidence-based testing decision.
          </p>

          <div className="mt-6 rounded-2xl border-2 border-alert bg-alert-soft p-4 text-left sm:p-5" data-id="element-206" data-mp="3rtfh4ispupnw">
            <p className="font-display text-2xl font-extrabold uppercase leading-tight text-white sm:text-3xl" data-id="element-207" data-mp="seamtlxxmkut">
              Stop random testing. Stop guessing which part to replace.
            </p>
            <p className="mt-1 font-display text-2xl font-extrabold uppercase leading-tight text-brand sm:text-3xl" data-id="element-208" data-mp="iohb8kxsi5qk">
              Follow one clear diagnostic pathway.
            </p>
          </div>

          <img src={MOCKUP_URL} alt="Automotive No-Start Diagnostic Blueprint: 6 volumes and 5 bonuses" className="mx-auto mt-8 w-full max-w-xl lg:hidden" data-id="element-209" data-mp="1b4jpsy1jmgnk" />

          <p className="mt-8 text-base leading-relaxed text-body sm:text-lg" data-id="element-210" data-mp="30m77i8n9v27o">
            Use the <strong className="text-white" data-id="element-211" data-mp="35l0k7yuqip6s">NO-START DIAGNOSTIC PATHWAY™</strong> to organize no-crank and crank-no-start
            investigations into six practical stages—complete with testing sequences, decision trees, professional checklists, and
            documentation tools.
          </p>
          <p className="mt-3 text-base leading-relaxed text-body sm:text-lg" data-id="element-212" data-mp="2hvfp6hlb41h5">
            Go from an unorganized troubleshooting process to a completed diagnostic worksheet that shows what you’ve checked, what
            you’ve found, and what to investigate next.
          </p>
          <p className="mt-4 text-sm font-semibold uppercase tracking-wide text-muted" data-id="element-213" data-mp="27zcozha0mcwu">
            Created by <span className="text-white" data-id="element-214" data-mp="2cyfiq5kjowpi">Jason Mitchell</span>
          </p>
        </div>

        <div className="hidden lg:block" data-id="element-215" data-mp="66ogaselqx9o">
          <img src={MOCKUP_URL} alt="Automotive No-Start Diagnostic Blueprint: 6 volumes and 5 bonuses" className="w-full" data-id="element-216" data-mp="b4pzddc12wl5" />
        </div>
      </div>

      <div className="mx-auto max-w-4xl px-4 pb-16" data-id="element-217" data-mp="1vnk4cxqanv65">
        <div className="rounded-3xl border border-line bg-panel p-5 sm:p-8" data-id="element-218" data-mp="1qofsu0fwdlcn">
          <h2 className="text-center font-display text-2xl font-extrabold uppercase text-white sm:text-3xl" data-id="element-219" data-mp="25ctsk2i0otoz">
            Your Complete No-Start Diagnostic System Includes:
          </h2>
          <ul className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-220" data-mp="20kag58v2g4lr">
            {heroIncludes.map(item => <li key={item} className="flex items-start gap-3 text-base font-medium text-white sm:text-lg" data-id="element-221" data-mp="2efcw6otmnaca">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-ok" data-id="element-222" data-mp="2obo6xadkjs4m">
                  <CheckIcon className="h-4 w-4 text-ink" strokeWidth={3} aria-hidden="true" data-id="element-223" data-mp="2jcuwxrxhqj97" />
                </span>
                {item}
              </li>)}
          </ul>
          <CtaButton id="first-cta" className="mt-8" label="Get My Complete Diagnostic System — $27" sub="One-Time Payment | Instant Digital Access | 7-Day Guarantee" data-id="element-224" data-mp="oyk6jf18zh1b" />
        </div>
      </div>
    </header>;
}